<template>
  <b-modal
    ref="modalSuccessSubmission"
    hide-footer
    hide-header
    modal-class="modal-dark"
    size="sm"
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-img
      width="100"
      src="https://storage.googleapis.com/komerce/assets/icons/success.svg"
      alt="Penambahan produk berhasil diajukan ke gudang"
      class="mx-auto my-[16px] size-[68px]"
    />
    <p class="text-center text-black font-semibold text-[20px] mb-[8px]">
      Produk sedang diajukan
    </p>
    <p class="text-center text-black">
      Gudang akan meninjau produk kamu. Mohon ditunggu ya
    </p>
    <b-button
      variant="primary"
      class="!w-full"
      :disabled="isHideBtnClicked"
      @click="hide"
    >
      Selesai
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSuccessSubmission',
  data() {
    return {
      isFromDetailGudang: false,
      mitraId: null,
      warehouseId: null,
      isHideBtnClicked: false,
    }
  },
  methods: {
    show({ isFromDetailGudang, mitraId, warehouseId }) {
      this.isFromDetailGudang = isFromDetailGudang
      this.mitraId = mitraId
      this.warehouseId = warehouseId
      this.$refs.modalSuccessSubmission.show()
    },
    hide() {
      this.isHideBtnClicked = true
      if (this.isFromDetailGudang) {
        this.$router.go(-1)
      } else {
        this.$router.replace({
          path: `/detail-gudang-kompack/${this.mitraId}`,
          query: { wid: this.warehouseId },
        })
      }
      this.$refs.modalSuccessSubmission.hide()
    },
  },
}
</script>
